document.addEventListener("DOMContentLoaded", () => {

    let blogCategoryButtons = document.querySelectorAll('.blog-section__navigation button');
    let blogItems = document.querySelectorAll('.blog-item');
    if (blogCategoryButtons) {
        blogCategoryButtons.forEach((button) => {
            button.addEventListener('click', () => {
                let categoryId = button.getAttribute('data-category-id');

                blogCategoryButtons.forEach((item)=>{
                    item.classList.remove('active');
                });
                button.classList.add('active');

                blogItems.forEach((item) => {
                    let postCategoryId = item.getAttribute('data-post-category-id');
                    if (postCategoryId === categoryId) {
                        item.classList.remove('hidden');
                        item.classList.add('animate__animated');
                    } else {
                        item.classList.add('hidden');
                    }
                })
            })
        })
    }
});
